var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils, LogLevel } from './_default-imports';
import { CustomTypedEvent } from '../../events';
//namespace Pacem.Components {
export const ResizeEventName = 'resize';
export class ResizeEvent extends CustomTypedEvent {
    constructor(args) {
        super(ResizeEventName, args);
    }
}
const BORDER_BOX = { box: 'border-box' };
let PacemResizeElement = class PacemResizeElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._checkSizeHandler = () => {
            this._assignSizeDebounced();
        };
    }
    get _target() {
        return this.target || this;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'disabled':
                this._start();
                break;
            case 'target':
                if (!Utils.isNull(this._observer)) {
                    var oldTarget = old || this;
                    this._observer.unobserve(oldTarget);
                }
            case 'watchPosition':
                var newTarget = this.target || this;
                if (!Utils.isNull(this._observer)) {
                    this._observer.observe(newTarget, BORDER_BOX);
                }
                break;
        }
    }
    _start() {
        // disabled? switch to stop
        if (this.disabled) {
            this._stop();
            return;
        }
        if (this.watchPosition) {
            this._startWatchIntensively();
        }
        else {
            // native ResizeObserver
            this._observer = new ResizeObserver(entries => {
                var changed = false;
                for (let entry of entries) {
                    if (entry.target !== this._target) {
                        continue;
                    }
                    if (entry.contentRect) {
                        changed = true;
                        break;
                    }
                }
                if (changed) {
                    // ResizeObserverEntry pieces of info aren't accurate,
                    // but useful enough to let punctually debounce
                    // the expensive request
                    this._assignSizeDebounced();
                }
            });
            this._observer.observe(this._target, BORDER_BOX);
        }
        window.addEventListener('resize', this._checkSizeHandler, false);
    }
    _stop() {
        window.cancelAnimationFrame(this._handle);
        window.removeEventListener('resize', this._checkSizeHandler, false);
        if (!Utils.isNull(this._observer)) {
            this._observer.disconnect();
            this._observer = null;
        }
    }
    _startWatchIntensively() {
        this._checkSize();
        this._handle = window.requestAnimationFrame(() => {
            this._startWatchIntensively();
        });
    }
    //@Throttle(true)
    _assignSizeDebounced() {
        this._checkSize();
    }
    _checkSize() {
        this.log(LogLevel.Log, 'Resize flow triggered.');
        let el = this._target;
        const rect = Utils.offset(el);
        let height = rect.height;
        let width = rect.width;
        if (height != this._previousHeight
            || width != this._previousWidth
            || (this.watchPosition &&
                (rect.left != this._previousLeft
                    || rect.top != this._previousTop))) {
            this._previousHeight = height;
            this._previousWidth = width;
            this._previousLeft = rect.left;
            this._previousTop = rect.top;
            this._dispatchResize();
        }
    }
    get currentSize() {
        var args = { height: this._previousHeight, width: this._previousWidth };
        if (this.watchPosition) {
            args.left = this._previousLeft;
            args.top = this._previousTop;
        }
        return args;
    }
    _dispatchResize() {
        this.dispatchEvent(new ResizeEvent(this.currentSize));
    }
    connectedCallback() {
        super.connectedCallback();
        this._start();
    }
    disconnectedCallback() {
        this._stop();
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemResizeElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemResizeElement.prototype, "watchPosition", void 0);
PacemResizeElement = __decorate([
    CustomElement({ tagName: P + '-resize' })
], PacemResizeElement);
export { PacemResizeElement };
//}
